// extracted by mini-css-extract-plugin
module.exports = {"popup":"NotesHistoryPopup_popup__rMVCy","notes":"NotesHistoryPopup_notes__hIR9y","note":"NotesHistoryPopup_note__2NSx6"};